import api from '../assets/api.png'
import cpp from '../assets/cpp.png'
import css from '../assets/css.png'
import email from '../assets/email.png'
import mobile from '../assets/mobile.png'

import angular from '../assets/skills/angular.png'
import cypress from '../assets/skills/cypress.webp'
import firebase from '../assets/skills/firebase.png'
import git from '../assets/skills/git.png'
import graphql from '../assets/skills/graphql.png'
import html from '../assets/skills/html.png'
import javascript from '../assets/skills/js.png'
import react from '../assets/skills/react.webp'
import redux from '../assets/skills/redux.png'
import tailwind from '../assets/skills/tailwind.png'
import typescript from '../assets/skills/typescript.png'

import about01 from '../assets/about01.png'
import about02 from '../assets/about02.png'
import about03 from '../assets/about03.png'
import about04 from '../assets/about04.png'

import circle from '../assets/circle.svg'
import logo from '../assets/logo.png'
import profile from '../assets/profile.png'

import adidas from '../assets/adidas.png'
import amazon from '../assets/amazon.png'
import asus from '../assets/asus.png'
import bolt from '../assets/bolt.png'
import nb from '../assets/nb.png'
import skype from '../assets/skype.png'
import spotify from '../assets/spotify.png'

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  git,
  graphql,
  html,
  javascript,
  react,
  redux,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  angular,
  tailwind,
  cypress,
  firebase,
}
